import { InputLabel } from '@material-ui/core';

import { withStyles } from '@material-ui/core';

export const DefaultInputLabel= withStyles({
  root: {
    fontSize: '16px',
  },
})(InputLabel);
